import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./aifordefenseaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const AIforDefenseAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/wcc/r/3147380/4536A132820893261AF173F3BF5A6363" target="_blank" className="pinkify">Watch SNG Live: AI for Defense On-Demand</a>. We had a great event with top leaders and decision makers across DOD and industry who discussed the role of AI in the military today and the promise of AI in the future.<br /><br />

Our first panel, Human-Centered AI, featured a discussion with Dr. Bruce Draper, Program Manager within DARPA's Information Innovation Office and
Josh Marcuse, Head of Strategy & Innovation for the Global Public Sector at Google Cloud.<br /><br />

Next, Dr. Paul Roysdon, Chief Solutions Architect, AI/ML at Leidos and Scarlett Swerdlow, Digital Service Expert at the Defense Digital Service discussed Accelerating Digital Innovation for Warfighters.<br /><br />

During our third panel, Hugo Latapie, Principal Engineer, Emerging Technologies and Incubation, at Cisco and Eileen Vidrine, Chief Data Officer of the U.S. Air Force provided insights on Data As a Foundation.<br /><br />

Our fourth panel, Finding Commercial Solutions for DOD's Data, featured Sarah Pearson, Commercial Executive for AI/ML at the Defense Innovation Unit and Terry Halvorsen, GM, Client & Solutions Development, Federal & Public Sector at IBM.<br /><br />

Our fifth panel, The Military's Adoption of AI, featured Michael Galbraith, Chief Digital Innovation Officer of the Dept. of Navy and Chris Whitlock, Managing Director at  Deloitte Consulting LLP.<br /><br />

To close out the event, Dr. Nathaniel J. Fuller, Technologist & Support to the Chief Data Office, DOD provided insight on Data in the DOD.<br /><br />
                    </p>
                        
                        <p>
                            <a className="regmobwatch" href="https://event.on24.com/wcc/r/3147380/4536A132820893261AF173F3BF5A6363" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/wcc/r/3147380/4536A132820893261AF173F3BF5A6363" target="_blank">WATCH NOW »</a>
                        
                    </div>
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "may13")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                        {/*<div className="botbuttons">
                            <h2 className="sponsor" id="Sponsors">BECOME A SPONSOR</h2>
                            <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                            <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                        </div>*/}
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "may13")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default AIforDefenseAboutWrap